import React, { useState, useEffect } from "react";
import DonutChart from "../utils/graphs/DonutChart";
import UserLayout from "../utils/user/UserLayout";
import { connect } from "react-redux";
import { fetchDashboardAction } from "../../redux/actions/dashboard/dashboardAction";
import LineChart from "../utils/graphs/LineChart";
import { fetchAnalyticsAction } from "../../redux/actions/analytics/analyticsAction";
import HorizontalChart from "../utils/graphs/HorizontalChart";
import ReactTooltip from "react-tooltip";
import MyContactsLocation from "../network/MyContactsLocation";
import {
  fetchMyContactsImagesAction,
  fetchMyContactsLocationMapAction,
  fetchPendingConnectionRequestsAction,
} from "../../redux/actions/network/networkAction";
import PerformanceColumnSmall from "../utils/graphs/PerformanceColumnSmall";
import BarLineChart from "../utils/graphs/BarLineChart";
import PerformanceGrid from "../utils/graphs/PerformanceGrid";
import BarLineCharts from "../utils/graphs/BarLineCharts";
import { IMAGEAPI } from "../../BackendConnections";
import HexagonGallery from "../network/HexagonGallery";
import { borderColor, borderRadius } from "@mui/system";
import DonutLegend from "../utils/graphs/DonutLegend";
import DonutTest from "../utils/graphs/DonutTest";
import ProfileStatusPie from "../utils/graphs/ProfileStatusPie";
import PerformanceColumn from "../utils/graphs/PerformanceColumn";
import SystemExpHalf from "../utils/graphs/SystemExpHalf";
import DonutDash from "../utils/graphs/DonutDash";
import DashboardStats from "./DashboardStats";
import ProfileStatus from "./ProfileStatus";

export const Dashboard = ( props) => {
//  console.log(props);
  const [experience, setExperience] = useState({
    value: 0,
    text: "",
    bgcolor: "#2BB4B0",
    type: "",
    isDisplayVal: true,
  });
  const [qualification, setQualification] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [coursesTraining, setCoursesTraining] = useState({
    value: 0,
    text: "",
    bgcolor: "#d3eaf3",
    type: "",
    isDisplayVal: true,
  });
  const [systems, setSystems] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [competences, setCompetences] = useState({
    value: 0,
    text: "",
    bgcolor: "#d3eaf3",
    type: "",
    isDisplayVal: true,
  });

  const [primaryJobTitle, setPrimaryJobTitle] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });

  const [secodaryJobTitle, setSecondaryJobTitle] = useState({
    value: null,
    text: null,
    bgcolor: "#e73f26",
    type: "/100",
    isDisplayVal: true,
  });

  const [primaryFunction, setPrimaryFunction] = useState({
    value: null,
    text: null,
    bgcolor: "#e73f26",
    type: "/100",
    isDisplayVal: true,
  });

  const [secondaryFunction, setSecondaryFuncton] = useState({
    value: null,
    text: null,
    bgcolor: "#e73f26",
    type: "/100",
    isDisplayVal: true,
  });

  const [primaryCategory, setPrimaryCategory] = useState({
    value: null,
    text: null,
    bgcolor: "#e73f26",
    type: "/100",
    isDisplayVal: true,
  });

  const [secondaryCategory, setSecondaryCategory] = useState({
    value: props.dashboard.average_skills_score,
    text: null,
    bgcolor: "#e73f26",
    type: "/100",
    isDisplayVal: true,
  });
  const [peerSeries, setPeerSeries] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);
  const [series, setSeries] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);
  const [referenceDonut, setReferenceDonut] = useState([
    ["Total reference sent", 0],
    ["Total reference received", 0],
  ]);
  const [reference, setReference] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  // const [referenceSent ,setReferenceSent] = useState('')
  // const [referenceReceived ,setReferenceReceived] = useState('')

  const [data, setData] = useState([0, 0, 0, 0]);
  const [peerData, setPeerData] = useState([0, 0, 0, 0]);
  const [content, setContent] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
          };
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);

  // const [pendingConnection, setPendingConnection] = useState([]);
  // const handleWithdrawPendingChange = (index) => {
  //   const values = [...pendingConnection];
  //   const receiver = values.splice(index, 1);
  //   setPendingConnection(values);
  //   const data = {
  //     receiver: receiver[0]["id"],
  //   };
  //   props.withdrawPendingConnection(receiver, data);
  // };
  // const handleRemoveFormConnection = (index) => {
  //   const values = [...pendingConnection];
  //   values.splice(index, 1);
  //   setPendingConnection(values);
  // };
  // const [dataN, setDataN] = useState({
  //   is_pending_connections: false,
  // });
  const [images, setImages] = useState([]);
  const [iData, setiData] = useState({
    is_myContacts: false,
    is_location: false,
  });
  useEffect(() => {
    // if (
    //   props.pendingConnectionRequests.length === 0 &&
    //   dataN.is_pending_connections === false
    // ) {
    //   setDataN((prevState) => ({ ...prevState, is_pending_connections: true }));
    //   props.fetchPendingConnectionRequests(props.profile.id);
    // }
    // if (props.pendingConnectionRequests) {
    //   setPendingConnection(props.pendingConnectionRequests);
    // }
    // if (props.myContacts.length) === 0 {
    //   setData((prevState) => ({ ...prevState }));
    //   props.fetchMyContactsImages(props.profile.id);
    // }

    if (Object.keys(props.dashboard).length === 0) {
      props.fetchDashboard();
    }
    if (Object.keys(props.analytics).length === 0) {
      props.fetchAnalytics();
    }
    if (Object.keys(props.dashboard).length > 0) {
      setPrimaryJobTitle((prevState) => ({
        ...prevState,
        // value: props?.dashboard?.avg_primary_jobTitle,
        value: props?.dashboard?.user_primary_jobTitle_pro,
        
      }));
      setExperience((prevState) => ({
        ...prevState,
        // value: props?.dashboard?.user_experience_score,
        value: props?.dashboard?.user_experience_score_pro,

      }));
      setQualification((prevState) => ({
        ...prevState,
        // value: props?.analytics?.qualification_score,
        value: props?.dashboard?.user_qualification_score_pro,

      }));
      setCoursesTraining((prevState) => ({
        ...prevState,
        // value: props?.analytics?.statutory_industry_score,
        value: props?.dashboard?.user_training_pro,

      }));
      setCompetences((prevState) => ({
        ...prevState,
        // value: props?.profile?.competencies_score,
        value: props?.dashboard?.user_competencies_score_pro,

      }));
      setSecondaryJobTitle((prevState) => ({
        ...prevState,
        value: props.dashboard.average_qualification_score,
      }));
      setPrimaryFunction((prevState) => ({
        ...prevState,
        value: props.dashboard.average_statutory_industry_score,
      }));
      setSecondaryFuncton((prevState) => ({
        ...prevState,
        value: props.dashboard.average_systems_score,
      }));
      setPrimaryCategory((prevState) => ({
        ...prevState,
        value: props.dashboard.average_competencies_score,
      }));
      setSecondaryCategory((prevState) => ({
        ...prevState,
        value: props.dashboard.average_skills_score,
      }));
      setReference((prevState) => ({
        ...prevState,
        value: props?.dashboard?.pro_total_received_references,
      }));
      setData([
        props?.dashboard?.user_experience_score,
        props?.analytics?.qualification_score,
        props?.analytics?.statutory_industry_score,
        props?.analytics?.systems_score,
      ]);
      setPeerData([
        props?.dashboard?.average_peer_experience_score,
        props?.dashboard?.average_peer_qualification_score,
        props?.dashboard?.average_peer_training_score,
        props?.dashboard?.average_peer_systems_score,
      ]);
    }
    if (
      Object.keys(props.analytics).length > 0 &&
      Object.keys(props.dashboard).length > 0
    ) {
      setSeries([
        [
          "Primary Job ",
          props.dashboard.primary_job_title_years_experience,
        ],
        ["Experience", props.dashboard.user_experience_score],
        ["Qualifications", props.analytics.qualification_score],
        ["Training", props.analytics.statutory_industry_score],
        ["Systems", props.analytics.systems_score],
        ["Competencies", props.analytics.competencies_score],
      ]);
      setPeerSeries([
        ["Primary Job ", props.dashboard.maximum_primary_jobTitle],
        ["Experience", props.dashboard.maximum_experience_score],
        ["Qualifications", props.dashboard.maimum_qualification_score],
        ["Training", props.dashboard.maximum_traning_score],
        ["Systems", props.dashboard.maximum_systems_score],
        ["Competencies", props.dashboard.maximum_competencies_score],
      ]);
      setReferenceDonut([
        ["Total reference sent", props.dashboard.total_reference_sent],
        ["Total reference received", props.dashboard.total_received_references],
      ]);
      // setReferenceSent(props.dashboard.total_reference_sent);
      // setReferenceReceived( props.dashboard.total_received_references);
    }
    // if (Object.keys(props.dashboard).length > 0) {
    // }
    if (Object.keys(props.profile).length > 0) {
      setSystems((prevState) => ({
        ...prevState,
        // value: props.profile.systems_score,
        value: props.dashboard.user_systems_score_pro,

      }));
      if (props.myContacts.length === 0 && iData.is_myContacts === false) {
        setiData((prevState) => ({ ...prevState, is_myContacts: true }));
        props.fetchMyContactsImages(props.profile.id);
      }

      if (props.myContacts.length > 0) {
        const result = Object.keys(props.myContacts).map(
          (image) => IMAGEAPI + props.myContacts[image]["profile_pic"]
        );
        setImages(result);

        if (props.locationMap.length === 0 && iData.is_location === false) {
          setiData((prevState) => ({ ...prevState, is_location: true }));
          props.fetchMyLocation(props.profile.id);
        }
      }
    }
    // if (props.myContacts.length > 0) {
    //   const result = Object.keys(props.myContacts).map(
    //     (image) => IMAGEAPI + props.myContacts[image]["profile_pic"]
    //   );
    //   setImages(result);
    // }
  }, [props.profile, props.dashboard, props.myContacts, props.analytics]);


// // Add this useEffect hook to log the dashboard data when it changes
// useEffect(() => {
//   if (Object.keys(props.dashboard).length > 0) {
//     console.log("Dashboard API Response:", props.dashboard);
//     console.log("Reference Data:", {
//       total_reference_sent: props.dashboard.total_reference_sent,
//       total_received_references: props.dashboard.total_received_references,
//       pro_total_received_references: props.dashboard.pro_total_received_references
//     });
//   }
// }, [props.dashboard]);

// // Also add this to check the reference state
// useEffect(() => {
//   console.log("Reference State:", reference);
// }, [reference]);

  return (
    <UserLayout>
      <div className="right-section" 
      // style={{ paddingLeft: "20px" }}
      style={ isMobile ? {} : { paddingLeft: "20px"}}
      >
        <div className="dashboard">
          {/* <div className="row align-items-end mb-65 lr-pad ">
          <div className="col-sm-12 col-12">
            <div className="inner-content primary-content">
              <img
                src="\assets\images\Asset 1.png"
                alt=""
                style={{ width: "100%" }}
              />
              <div className="d-flex title-icon-box mb-4">
                <h2 className="page-title">
                  MY
                  <br />
                  <strong style={{ fontSize: "50px" }}>Performance</strong>
                </h2>
                <img
                  className="mb-4  img-fluid"
                  src="/assets/images/quick-links/performance.svg"
                  alt=""
                  style={{ width: "100px", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </div> */}
          <div className="content-wrapper">
            <div className="main-content" >
              <div className="dash-content" style={{ marginLeft: "-30px" }}>
                <div className="banner-container">
                  <div className="banner">
                    <div className="banner-title-overlay">
                      <h5>
                        <span>
                          MY
                          <br />
                          <b>Dashboard</b>
                          <hr className="bannerhr" style={{ height: "5px", background: "white",width:'75%' }} />
                        </span>
                      </h5>
                      <img
                        src="\assets\images\icons\Asset 2.png"
                        className="icon-image "
                      />
                    </div>

                    <img
                      className="banner-image"
                      src="\assets\images\Asset 1.png"
                      alt="Not Found"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="dashboard-padding"
            style={{
              backgroundColor: "#ececee",
              // backgroundColor: "#ff0000ff",
              borderRadius: "5px",
              // paddingRight: "30px",
              paddingRight: isMobile ? "15px" : "30px",
            }}
          >
            <div className="row">
              <div className="col-12 card-block synopsis-padding">
                <div className="card-border" style={{ background: "white" }}>
                  <div className="row synopsis-area">
                    <div className="col-12">
                      <div id="customLegend"></div>
                      <div className="graph-block">
                        <h6 className="title" style={{ color: "#283270" }}>
                          MY <b>Profile Score</b> v's
                          <b> Maximum Available Score</b>
                        </h6>
                        <LineChart data={series} data2={peerSeries} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 synopsis-padding-peer-group">
                <div className="graph-block graph-block-row ">
                  <div className="block-title pt-2 " style={{ color: "white" }}>
                    MY <b>Scores</b> v's MY <b> PEER Group Averages</b>
                  </div>
                  <div className="row">
                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap ">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {" "}
                            <DonutDash
                              data={primaryJobTitle}
                              maximum={
                                props?.dashboard?.maximum_primary_jobTitle
                              }
                              label={
                                props?.dashboard?.primary_jobTitle_label ===
                                undefined
                                  ? "No data"
                                  : props?.dashboard?.primary_jobTitle_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            PRIMARY JOB 
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {" "}
                            {/* <DonutChart data={secodaryJobTitle} /> */}
                            <DonutDash
                              data={experience}
                              maximum={
                                props?.dashboard?.maximum_experience_score
                              }
                              label={
                                props?.dashboard?.experience_label === undefined
                                  ? "No data"
                                  : props?.dashboard?.experience_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            EXPERIENCE
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {" "}
                            {/* <DonutChart data={primaryCategory} /> */}
                            <DonutDash
                              data={qualification}
                              maximum={
                                props?.dashboard?.maimum_qualification_score
                              }
                              label={
                                props?.dashboard?.qualification_label ===
                                undefined
                                  ? "No data"
                                  : props?.dashboard?.qualification_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            QUALIFICATIONS
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {/* <DonutChart data={secondaryCategory} /> */}
                            <DonutDash
                              data={coursesTraining}
                              maximum={props?.dashboard?.maximum_traning_score}
                              label={
                                props?.dashboard?.training_label === undefined
                                  ? "No data"
                                  : props?.dashboard?.training_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            TRAINING
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {" "}
                            {/* <DonutChart data={primaryFunction} /> */}
                            <DonutDash
                              data={systems}
                              maximum={props?.dashboard?.maximum_systems_score}
                              label={
                                props?.dashboard?.systems_label === undefined
                                  ? "No data"
                                  : props?.dashboard?.systems_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            SYSTEMS
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4 col-6">
                      <div className="graph-wrap">
                        <div className="graph-block">
                          <div
                            id="peerGraph"
                            className="custom-circle-progress label-center"
                          >
                            {" "}
                            {/* <DonutChart data={secondaryFunction} /> */}
                            <DonutDash
                              data={competences}
                              maximum={
                                props?.dashboard?.maximum_competencies_score
                              }
                              label={
                                props?.dashboard?.competencies_label ===
                                undefined
                                  ? "No data"
                                  : props?.dashboard?.competencies_label
                              }
                            />
                          </div>
                        </div>
                        <div className="graph-footer">
                          <div
                            className="graph-title"
                            style={{ textAlign: "center" }}
                          >
                            COMPETENCIES
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12" style={isMobile ? {paddingRight: "0px"}: {}}>
                <div className="row small-gutter">
                  <div className="col-lg-4 col-md-6 col-12">
                    <ProfileStatus
                      agencies={
                        props?.dashboard?.total_agency_count === undefined
                          ? 0
                          : props?.dashboard?.total_agency_count
                      }
                      companies={
                        props?.dashboard?.total_company_count === undefined
                          ? 0
                          : props?.dashboard?.total_company_count
                      }
                      organisations={
                        props?.dashboard?.total_organization_count === undefined
                          ? 0
                          : props?.dashboard?.total_organization_count
                      }
                      individual={
                        props?.dashboard?.total_individual_count === undefined
                          ? 0
                          : props?.dashboard?.total_individual_count
                      }
                    />
                    {/* <div
                      className="card-tile bg-light"
                      style={{ color: "#283270" }}
                    >
                      <strong>MY Profile Status</strong>
                      <div
                        id="peerGroupperformanceone"
                        className="equal-height-graph pt-4"
                      >
                        <div className="row d-flex ">
                          <div
                            className="col-md-6 d-flex align-items-center text-center"
                            style={{ paddingLeft: "40px" }}
                          >
                            <div style={{ maxWidth: "25%" }}>
                              <span
                                className="ni nicon-agencies"
                                style={{ color: "#2bb4b0", fontSize: "40px" }}
                              ></span>
                              <p>AGENCIES</p>
                            </div>{" "}
                            <div
                              class="image-container"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/images/hexagon-green.svg"
                                alt=""
                                className="img-fluid"
                              />
                              <div class="text-overlay">
                                {props?.dashboard?.total_agency_count}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 d-flex align-items-center text-center">
                            <div style={{ maxWidth: "25%" }}>
                              <span
                                className="ni nicon-companies"
                                style={{ color: "#2bb4b0", fontSize: "40px" }}
                              ></span>
                              <p>COMPANIES</p>
                            </div>{" "}
                            <div
                              class="image-container"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/images/hexagon-green.svg"
                                alt=""
                                className="img-fluid"
                              />
                              <div class="text-overlay">
                                {props?.dashboard?.total_company_count}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row d-flex">
                          <div
                            className="col-md-6 d-flex align-items-center text-center"
                            style={{ paddingLeft: "40px", paddingTop: "30px" }}
                          >
                            <div style={{ maxWidth: "25%" }}>
                              <span
                                className="ni nicon-companies"
                                style={{ color: "#2bb4b0", fontSize: "40px" }}
                              ></span>
                              <p>COMPANIES</p>
                            </div>{" "}
                            <div
                              class="image-container"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/images/hexagon-green.svg"
                                alt=""
                                className="img-fluid"
                              />
                              <div class="text-overlay">
                                {props?.dashboard?.total_company_count}
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-md-6 d-flex align-items-center text-center"
                            style={{ paddingTop: "30px" }}
                          >
                            <div style={{ maxWidth: "25%" }}>
                              <span
                                className="ni nicon-individual"
                                style={{ color: "#2bb4b0", fontSize: "40px" }}
                              ></span>
                              <p>INDIVIDUALS</p>
                            </div>{" "}
                            <div
                              class="image-container"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/images/hexagon-green.svg"
                                alt=""
                              />
                              <div class="text-overlay">
                                {props?.dashboard?.total_individual_count}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div className="col-lg-4 col-md-6 col-12">
                    {/* <div className="subtitle"> */}
                    {/* <strong>MY NETWORK</strong> */}
                    {/* </div> */}
                    <div
                      style={{ maxHeight: "295px" }}
                      className="card-tile orange-bg"
                    >
                      <MyContactsLocation
                        markers={props.locationMap}
                        setTooltipContent={setContent}
                      />
                      {/* <ReactTooltip>{content}</ReactTooltip> */}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 ">
                    {/* <div className="subtitle"></div> */}
                    <div
                      className="card-tile bg-light"
                      style={{ color: "#283270" }}
                    >
                      <span className="my-score-text">
                        MY<strong> Score</strong> v’s MY{" "}
                        Network <strong> Peers</strong>
                      </span>
                      <div
                        id="peerGroupperformanceone"
                        className="equal-height-graph"
                      >
                        <PerformanceColumn
                          peersData={peerData}
                          data={data}
                          height={250}
                          color={"black"}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="card-tile bg-light">
                      <h6 className="title" style={{ color: "#283270" }}>
                        {" "}
                        MY <b>Systems Experience</b>{" "}
                      </h6>
                      <div className="grid-item">
                        <div className="inner-wrap">
                          <div className="gridGraphNew grey-svg">
                            <SystemExpHalf
                              data={
                                props?.dashboard?.user_systems_score ===
                                undefined
                                  ? 0
                                  : props?.dashboard?.user_systems_score
                              }
                              color={"black"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="card-tile bg-light">
                      <h6 className="title " style={{ color: "#283270" }}>
                        MY <strong> Network Status</strong>
                      </h6>
                      <div className="grid-item">
                        <div className="inner-wrap">
                          <div className="gridGraphNew grey-svg">
                            {/* &nbsp; */}
                            <div className="row text-center ">
                              <div className="col-6 ">
                                <div className="network-status-card blue">
                                  <h6
                                    // className="border border-5 border-primary"
                                    style={{
                                      marginLeft: "32px",
                                      marginRight: "32px",
                                      marginBottom:'6px',
                                      fontSize:'18px',
                                      borderRadius:'5px',
                                      border: '2px solid #007bff',
                                      padding: "11px",
                                    }}
                                  >
                                    <strong className="network-text">
                                      {props?.dashboard?.total_users_network ===
                                      undefined
                                        ? 0
                                        : props?.dashboard?.total_users_network}
                                    </strong>
                                  </h6>
                                  <p>My Network Total</p>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="network-status-card red">
                                  <h6
                                    // className="border border-danger  "
                                    style={{
                                      marginLeft: "32px",
                                      marginRight: "32px",
                                      marginBottom:'6px',
                                      fontSize:'18px',
                                      borderRadius:'5px',
                                      border: "2px solid #dc3545",
                                      padding: "11px",
                                    }}
                                  >
                                    <strong className="network-text">
                                      {" "}
                                      {props?.dashboard?.no_of_users_primary ===
                                      undefined
                                        ? 0
                                        : props?.dashboard?.no_of_users_primary}
                                    </strong>
                                  </h6>
                                  <p>Primary Job </p>
                                </div>
                              </div>
                            </div>
                            &nbsp;
                            <div className="row text-center ">
                              <div className="col-6">
                                <div className="network-status-card orange">
                                  <h6
                                    // className="border border-warning"
                                    style={{
                                      marginLeft: "32px",
                                      marginRight: "32px",
                                      marginBottom:'6px',
                                      fontSize:'18px',
                                      borderRadius:'5px',
                                      border: "2px solid #ffc107",
                                      padding: "11px",
                                    }}
                                  >
                                    <strong className="network-text">
                                      {" "}
                                      {props?.dashboard
                                        ?.no_of_users_secondary === undefined
                                        ? 0
                                        : props?.dashboard
                                            ?.no_of_users_secondary}
                                    </strong>
                                  </h6>
                                  <p>Secondary Job </p>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="network-status-card green">
                                  <h6
                                    // className="border border-info"
                                    style={{
                                      marginLeft: "32px",
                                      marginRight: "32px",
                                      marginBottom:'6px',
                                      fontSize:'18px',
                                      borderRadius:'5px',
                                      border: "2px solid #17a2b8",
                                      padding: "11px",
                                    }}
                                  >
                                    <strong className="network-text">
                                      {" "}
                                      {props?.dashboard
                                        ?.no_of_users_seeking_employment ===
                                      undefined
                                        ? 0
                                        : props?.dashboard
                                            ?.no_of_users_seeking_employment}
                                    </strong>
                                  </h6>
                                  <p>Seeking Employment</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="card-tile bg-light">
                      <h6 className="title" style={{ color: "#283270" }}>
                        MY <strong>References</strong>{" "}
                      </h6>
                      <div className="grid-item">
                        <div className="inner-wrap">
                          <div className="gridGraphNew grey-svg">
                            <div className="row">
                              <div
                                className=" col-6 col-md-4  p-2 circular-progress"
                                style={{ height:'84px', width:'auto'}}
                              >
                                <DonutTest
                                  data={reference}
                                  maximum={100}
                                  label={"HIGHER"}
                                />
                                {/* <div className="inner-circle" /> */}
                              </div>
                              <div className="col-6 col-md-7">
                                <h6
                                  className="mt-5"
                                  style={{ fontSize: "16px",color:'#' }}
                                >
                                  References
                                  <br /> Received
                                </h6>
                              </div>
                            </div>
                            <div className="bottom-process-bar">
                              <b style={{ fontSize: "20px" }}>
                                {reference.value}%
                              </b>
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  style={{
                                    width: `${reference.value}%`,
                                    background: "#fbc809",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserLayout>
  );
};
const mapStateToProps = (state) => {
  const user = state.user.user;
  const analytics = state.analytics.analytics;
  const profile = state.user.profile;
  const dashboard = state.dashboard.dashboard;
  const locationMap = state.network.locationMap;
  const myContacts = state.network.myContacts;
  // const pendingConnectionRequests = state.network.pendingConnectionRequests;
  return {
    user: user,
    profile: profile,
    analytics: analytics,
    dashboard: dashboard,
    locationMap: locationMap,
    myContacts: myContacts,
    // pendingConnectionRequests: pendingConnectionRequests,
  };
};
const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchDashboard: () => dispatch(fetchDashboardAction()),
    fetchAnalytics: () => dispatch(fetchAnalyticsAction()),
    fetchMyLocation: (profileId) =>
      dispatch(fetchMyContactsLocationMapAction(profileId)),
    // fetchPendingConnectionRequests: (profileId) =>
    //   dispatch(fetchPendingConnectionRequestsAction(profileId)),
    fetchMyContactsImages: (userId) =>
      dispatch(fetchMyContactsImagesAction(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);